export enum ServiceWorkerMessageType {
  ShowNotification = 'SHOW_NOTIFICATION',
  Navigate = 'NAVIGATE',
}
